import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import "../styles/cab-booking-success.css";

const CabBookingSuccess = () => {
  const location = useLocation();
  const booking = location.state?.booking;

  if (!booking) {
    return (
      <section className="booking__success__section">
        <Container>
          <Row>
            <Col lg="12" className="text-center">
              <div className="error__content">
                <i className="ri-error-warning-line"></i>
                <h2>No Booking Found</h2>
                <p>It seems you haven't made a booking yet.</p>
                <Link to="/cabs">
                  <Button className="primary__btn">Book a Cab</Button>
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }

  return (
    <section className="booking__success__section">
      <Container>
        <Row>
          <Col lg="8" className="m-auto">
            <div className="success__card">
              <div className="success__icon">
                <i className="ri-checkbox-circle-fill"></i>
              </div>
              
              <h2>Booking Confirmed!</h2>
              <p className="success__message">
                Thank you for your booking. Your cab has been reserved successfully.
              </p>

              <div className="booking__id">
                <span>Booking ID:</span>
                <strong>{booking.id}</strong>
              </div>

              <div className="booking__details__card">
                <h4>Booking Details</h4>
                
                <div className="detail__section">
                  <h5><i className="ri-car-line"></i> Vehicle Information</h5>
                  <div className="detail__row">
                    <span>Vehicle:</span>
                    <strong>{booking.cab.name}</strong>
                  </div>
                  <div className="detail__row">
                    <span>Type:</span>
                    <strong>{booking.cab.type}</strong>
                  </div>
                  <div className="detail__row">
                    <span>Base Fare:</span>
                    <strong>₹{booking.cab.basePrice}</strong>
                  </div>
                  <div className="detail__row">
                    <span>Per KM:</span>
                    <strong>₹{booking.cab.pricePerKm}</strong>
                  </div>
                </div>

                <div className="detail__section">
                  <h5><i className="ri-route-line"></i> Trip Details</h5>
                  <div className="detail__row">
                    <span>Pickup:</span>
                    <strong>{booking.trip.pickup}</strong>
                  </div>
                  <div className="detail__row">
                    <span>Drop:</span>
                    <strong>{booking.trip.drop}</strong>
                  </div>
                  <div className="detail__row">
                    <span>Date:</span>
                    <strong>{booking.trip.date}</strong>
                  </div>
                  <div className="detail__row">
                    <span>Time:</span>
                    <strong>{booking.trip.time}</strong>
                  </div>
                </div>

                <div className="detail__section">
                  <h5><i className="ri-user-line"></i> Customer Information</h5>
                  <div className="detail__row">
                    <span>Name:</span>
                    <strong>{booking.customer.fullName}</strong>
                  </div>
                  <div className="detail__row">
                    <span>Phone:</span>
                    <strong>{booking.customer.phone}</strong>
                  </div>
                  <div className="detail__row">
                    <span>Email:</span>
                    <strong>{booking.customer.email}</strong>
                  </div>
                </div>
              </div>

              <div className="success__note">
                <i className="ri-information-line"></i>
                <p>
                  A confirmation has been sent to your email. Our driver will contact 
                  you before the pickup time. For any queries, please contact our support.
                </p>
              </div>

              <div className="success__actions">
                <Link to="/my-cab-bookings">
                  <Button className="secondary__btn">
                    <i className="ri-history-line"></i> View My Bookings
                  </Button>
                </Link>
                <Link to="/cabs">
                  <Button className="secondary__btn">
                    <i className="ri-car-line"></i> Book Another Cab
                  </Button>
                </Link>
                <Link to="/home">
                  <Button className="primary__btn">
                    <i className="ri-home-line"></i> Go to Home
                  </Button>
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CabBookingSuccess;
